export function filterObjEmptyValue(obj: Recordable) {
  const result: Recordable = {}
  for (const key in obj) {
    if (obj[key] !== undefined) {
      result[key] = obj[key]
    }
  }
  return result
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function multiply(a: number, b: number) {
  const str1 = a.toString()
  const str2 = b.toString()
  const decimalLength1 = (str1.split('.')[1] || '').length
  const decimalLength2 = (str2.split('.')[1] || '').length
  const baseNum = 10 ** (decimalLength1 + decimalLength2)
  const num1 = Number(str1.replace('.', ''))
  const num2 = Number(str2.replace('.', ''))
  return Number(((num1 * num2) / baseNum).toFixed(2))
}
